import type { ViewState } from '#components/Root/viewModel'

import linkViewModel from '@vimcar/mvvm/linkViewModel'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import mkViewModel from './viewModel'

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomTextOnly = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
    </StepContent>
    {viewModel.showButtons && (
      <BottomActions
        // @ts-expect-error@2322
        onNext={viewModel.showContinue && viewModel.handleNext}
        showBack={viewModel.showBack}
        // @ts-expect-error@2339
        showClose={viewModel.showClose}
      />
    )}
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomTextOnly)
component.displayName = 'CustomTextOnly'
export default component
